import React from 'react';
import { ReadyState } from 'react-use-websocket';
import useSessionStoreContext from '../Contexts/SessionStoreContextProvider/useSessionStoreContext';
import useAudioServerCommunication from './useAudioServerCommunication';

export default function useHandleContextUpdate() {
  const { latestDetection: [latestDetection], sessionId: [sessionId], context: [context, setContext] } = useSessionStoreContext();
  const sessionIdRef = React.useRef<string | null>(sessionId);
  const { sendJsonMessage, readyState } = useAudioServerCommunication();
  const readyStateRef = React.useRef(readyState);

  React.useEffect(() => {
    if (sessionId !== sessionIdRef.current && context) {
      setContext(null);
    }
    sessionIdRef.current = sessionId;
  }, [sessionId, context]);

  React.useEffect(() => {
    if (latestDetection?.contextChange) {
      setContext(latestDetection.contextChange);
    }
  }, [latestDetection]);

  React.useEffect(() => {
    if (sessionIdRef.current) {
      sendJsonMessage({
        type: 'settings',
        context: context ?? '',
        date: Date.now() * 1e6,
      });
    }
  }, [context, sessionIdRef]);

  React.useEffect(() => {
    if (context && readyState === ReadyState.OPEN && readyStateRef.current !== readyState) {
      sendJsonMessage({
        type: 'settings',
        context,
        date: Date.now() * 1e6,
      });
    }
    readyStateRef.current = readyState;
  }, [context, readyState, sendJsonMessage]);
}
